import {PdsWidget} from './pds-widget';
import {NotificationBadge} from './interfaces/notification-badge';

export class PdsNotificationBadge extends PdsWidget {

  is: 'pds-notification-badge';
  id = '';
  badge: NotificationBadge | null;
  additionalStyles: string;
  dataNotificationCount: number | null;
  dataShowCount: 'true' | 'false' | null;
  dataSetContainerAutomatically: 'true' | 'false';

  properties = {
    //@deprecated
    //This is the old property that the widget is built on.
    //We can't change it because it might break something, but requiring JS to set this is really not good since it doesn't
    //NEED to be set this way.  Use dataNotificationCount and dataShowCount to set these values instead.
    badge: {
      type: Object,
      value: {
        badgeCount: 0,
        showCount: true
      }
    },
    dataNotificationCount: {
      type: Number,
      value: null,
      observer: 'updateBadgeObject'
    },
    dataShowCount: {
      type: String,
      value: 'true',
      observer: 'updateBadgeObject'
    },
    id: {
      type: String,
      value: ''
    },
    dataSetContainerAutomatically: {
      type: String,
      value: 'true' //If you set this to false, you must add the .pds-notification-badge-container class manually.
    },
    dataIsBadgeElevated: {
      type: String,
      value: 'false'
    }
  };

  attached(): void {
    super.attached();
    if (this.dataSetContainerAutomatically === 'true' && (<any>this).parentElement != null) {
      (<any>this).parentElement.classList.add('pds-notification-badge-container');
    }
  }

  updateBadgeObject(): void {
    //Build the new badge object.
    this.badge = {
      showCount: this.dataShowCount === 'true',
      badgeCount: this.dataNotificationCount || 0
    };
  }
}
